import { render, staticRenderFns } from "./extra-ticket-detail.vue?vue&type=template&id=f179d5d2&lang=pug&"
import script from "./extra-ticket-detail.vue?vue&type=script&lang=js&"
export * from "./extra-ticket-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports